import { Pipe, PipeTransform } from '@angular/core';
import { FINANCIAL_PEOPLE_SITUATION } from '@constants/financial-people-situation.constants';
import { ConstantModel } from '@core/models/outros/constant.model';

@Pipe({name: 'financialPeopleSituationPipe'})
export class FinancialPeopleSituationPipe implements PipeTransform {

  transform(value: string): string {
    let financialPeople = FINANCIAL_PEOPLE_SITUATION;
    financialPeople.push(
      {
        id: 'F',
        descricao: 'PESSOA FÍSICA',
        enum: 'F',
      },
      {
        id: 'J',
        descricao: 'PESSOA JURÍDICA',
        enum: 'J',
      }
    )
    let situation: ConstantModel = financialPeople.find(x => x.id == value);
    return situation ? situation.descricao : '-'
  }
}
